import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import CustomDialog from './inputs/CustomDialog';

import Loader from './Loader'
import VoucherCampaignEdit from './VoucherCampaignEdit'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { Control } from 'react-redux-form'

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import InstaTable from './InstaTable'

import {
  vouchers_index,
  activate_voucher,
  revoke_voucher,
  resend_voucher,
  clear_voucher,
  delete_voucher,
  coupons_select,
  templates_select,
  preferences_index,
  set_path,
  import_vouchers_csv,
  update_voucher,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals, campaigns } = state.voucher
  return {
    voucher: state.voucher,
    vouchers: items,
    campaigns: campaigns,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    coupons: state.coupon.select_items,
    templates: state.template.select_items,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getVouchers: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( vouchers_index(page, per_page, filters, sort, order) ),
    activateVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(activate_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    deleteVoucher: (voucher_id, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(delete_voucher(voucher_id, page, per_page, filters, sort, order)),
    revokeVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(revoke_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    resendVoucher: (voucher_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(resend_voucher(voucher_id, index, page, per_page, filters, sort, order)),
    getPreferences: () => dispatch( preferences_index() ),
    getCoupons: () => dispatch( coupons_select() ),
    getTemplates: () => dispatch( templates_select() ),
    clearVoucher: () => dispatch( clear_voucher() ),
    setPath: path => dispatch( set_path(path) ),
    importVouchers: values => dispatch( import_vouchers_csv(values) ),
    updateVoucher: (voucher_id, values) => dispatch( update_voucher(voucher_id, values, true) ),
  }
}

class ConnectedVouchersIndex extends React.Component {
  state={
    current_voucher: null,
    current_view: 'all',
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    mounted: false,
    modalOpen: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'user') {
      renderText = (
        <Link to={`/users/${item.buser_id}/edit`} className="test_results_link" title="Edit User" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.display_name}</div>
          <div className="td-user-name">{item.email}</div>
        </Link>
      )
    } else if (field === 'coupon') {
      renderText = item.coupon_name
    } else if (field === 'template') {
      renderText = item.template_name
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'discount') {
      renderText = item.discount > 0 ? `${parseInt(item.discount * 100, 10)} %` : `${item.value.toFixed(2)} €`
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { item.status === "revoked" && this.activateLink(item, state) }
          { item.status === "active" && this.revokeLink(item, state) }
          { item.status === "active" && this.resendLink(item, state) }
          { item.status === "active" && this.editCampaignLink(item, state) }
          { item.status === "revoked" && this.deleteLink(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getVouchers, getCoupons, getTemplates, getPreferences } = this.props
    getCoupons()
    getTemplates()
    getPreferences()
    getVouchers()
    this.props.setPath('vouchers')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.voucher.fetching && !this.props.voucher.fetching && this.props.voucher.fetched) {
        this.setState({mounted: true})
      }
    }
    if (prevProps.voucher && !prevProps.voucher.upload_success && this.props.voucher && this.props.voucher.upload_success) {
      const {filters, sort, order, page, per_page} = this.state
      this.props.getVouchers(page, per_page, filters, sort, order)
      this.setState({modalOpen: true})
      // window.showSnackbar("warning", this.props.voucher.warnings.join("\n"))
    }
  }

  handleModalClose = () => {
    this.setState({
      modalOpen: false,
      campaignDialogOpen: false
    })
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  activateLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Activate Voucher" onClick={e=>{
        e.preventDefault()
        this.props.activateVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
      </Link>
    )
  }

  revokeLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Revoke Voucher" onClick={e=>{
        e.preventDefault()
        this.props.revokeVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete</Icon>
      </Link>
    )
  }

  resendLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Resend Notification" onClick={e=>{
        e.preventDefault()
        this.props.resendVoucher(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>mail</Icon>
      </Link>
    )
  }

  deleteLink = (item, state) => {
    const {id} = item
    // const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Permanently delete" onClick={e=>{
          e.preventDefault()
          this.setState({showDialog: true, current_id: id, filterState: state})
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
      </Link>
    )
  }

  destroy = id => {
    const {filters, sort, order, page, per_page} = this.state.filterState
    this.props.deleteVoucher(id, page, per_page, filters, sort, order)
    this.hideDialog()
    this.setState({filterState: {}})
  }

  editCampaignLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Edit Campaign" onClick={e=>{
        e.preventDefault()
        this.setState({voucher_id: id, campaignDialogOpen: true, current_voucher: item})
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>gps_fixed</Icon>
      </Link>
    )
  }

  hideDialog() {
    this.setState({showDialog: false, current_voucher: {}})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'active') {
      icon = 'check_circle'
    } else if (status === 'consumed') {
      icon = "done_all"
    } else if (status === 'revoked') {
      icon = "delete"
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  showPreview = item => {
    // this.setState({showPreview: true, current_template: template})
  }

  handleUploadCSV = (model, values) => {
    if (values !== null && values !== undefined && values.length !== 0) {
      const {size, type} = values[0]
      if (type && !/.csv/.test(type)) {
        window.showSnackbar("error", "Upload failed. This has to be a CSV file.")
      } else {
        const formData = new FormData()
        formData.append('file', values[0], values[0].name)
        this.props.importVouchers(formData)
      }
    }
  }

  handleUpdateVoucher = (voucher_id, values) => {
    if (values !== null && values !== undefined && values.length !== 0) {
      // const formData = new FormData()
      this.props.updateVoucher(voucher_id, values)
      this.handleModalClose()
    }
  }

  headerButton = () => {
    return (
      <Hidden smDown>
        <Control.file
          id="csv-upload-selector"
          model="sea"
          changeAction={this.handleUploadCSV.bind(this)}
          accept=".csv"
          className="d-none"
        />
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center"
          style={{float: 'right'}}
          title="Columns: email, name, surname, voucher, campaign, template"
          onClick={e=> document.getElementById('csv-upload-selector').click()}
          >IMPORT FROM CSV
        </CustomOutlinedButton>
      </Hidden>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { vouchers, pagination, totals, coupons, templates, campaigns } = this.props
    const { current_voucher } = this.state

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'user', disablePadding: true, label: 'User' },
      { id: 'coupon', disablePadding: true, label: 'Coupon' },
      { id: 'campaign', disablePadding: true, label: 'Campaign' },
      { id: 'template', disablePadding: true, label: 'Template' },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'discount', disablePadding: true, label: 'Discount', disableSort: true  },
      { id: 'created_at', disablePadding: true, label: 'Creation' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "coupon", filter_type: "select", valueField: "name", collection: coupons },
      { name: "template", filter_type: "select", valueField: "name", collection: templates },
      { name: "campaign", filter_type: "select", valueField: "name", collection: campaigns },
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "consumed", label: "Consumed", value: totals.consumed },
      { name: "revoked", label: "Revoked", value: totals.revoked },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.voucher.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Vouchers
          </Typography>
          <CustomOutlinedButton
            component={Link}
            to="/vouchers/new"
            className="buttonnoto c-blue align-self-center"
            onClick={e=> this.props.setPath("addvoucher")}
            >Add Voucher
          </CustomOutlinedButton>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={vouchers}
          pagination={pagination}
          userRole={'client'}
          search={true}
          placeholders="ID, name, campaign"
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getVouchers.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="vouchers"
          addClassField="status"
          headerButton={this.headerButton.bind(this)}
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Voucher?"
        >
          This action cannot be undone
        </CustomDialog>

        <CustomDialog
          id="warnings-dialog"
          fullScreen={false}
          isopen={this.state.modalOpen}
          handleClose={false}
          handleAccept={this.handleModalClose.bind(this)}
          title="CSV Bulk Upload Log"
        >
          <pre>
            {this.props.voucher.warnings.join("\n")}
          </pre>
        </CustomDialog>

        <CustomDialog
          id="campaign-dialog"
          fullScreen={false}
          isopen={this.state.campaignDialogOpen}
          handleClose={false}
          handleAccept={false}
          height={50}
          title={""}
        >
          <VoucherCampaignEdit
            campaign={(current_voucher) ? current_voucher.campaign : ''}
            voucher_id={this.state.voucher_id}
            campaigns={campaigns}
            handleModalClose={this.handleModalClose.bind(this)}
            updateVoucher={this.handleUpdateVoucher.bind(this)}
          />
        </CustomDialog>

      </div>
    )
  }
}

const VouchersIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedVouchersIndex)

export default withStyles(styles)(VouchersIndex)



// WEBPACK FOOTER //
// ./src/js/components/VouchersIndex.js